import client from './api-client';
import { CONCEPTO_TIPO_GESTION } from '../common/tipos-gestion';

export const getCargasPrevias = async(query) => {
    try {
        
        const response = await client.get(`ingreso-caso/carga-masiva?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                cargas_previas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

// Tipos de gestión (IND 207) con su agrupación (grupo IND 314). q = base64 de un JSON.
export const getTiposGestion = async() => {
    try {

        const query = btoa(JSON.stringify({ concepto: CONCEPTO_TIPO_GESTION }));
        const response = await client.get(`detalles?q=${query}`);

        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const postCargarArchivo = async(file) => {
    try {
        
        const response = await client.post('ingreso-caso/carga-archivo', file);
        
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}